import React, { useState } from 'react';
import './MobileView.css';

const MobileViewCertificate = ({
    card1Front,
    card1Back,
    card2Front,
    card2Back,
    card3Front,
    card3Back
}) => {
    const [activeCard, setActiveCard] = useState(null);

    const handleCardClick = (index) => {
        setActiveCard(activeCard === index ? null : index);
    };

    return (
        <div className="mobile-flip-container">
            
            {/* Card 1 */}
            <div
                className={`mobile-flip-card1 ${activeCard === 0 ? 'active' : ''}`}
                onClick={() => handleCardClick(0)}
            >
                <div className="mobile-flip-card-inner">
                    <div className="mobile-flip-front">
                        <img
                            src={card1Front}
                            alt="Product Front"
                            className="mobile-flip-img"
                        />
                    </div>
                    <div className="mobile-flip-back">
                        <img
                            src={card1Back}
                            alt="Product Back"
                            className="mobile-flip-img"
                        />
                    </div>
                </div>
            </div>

            {/* Card 2 */}
            <div
                className={`mobile-flip-card2 ${activeCard === 1 ? 'active' : ''}`}
                onClick={() => handleCardClick(1)}
            >
                <div className="mobile-flip-card-inner">
                    <div className="mobile-flip-front">
                        <img
                            src={card2Front}
                            alt="Product Front"
                            className="mobile-flip-img"
                        />
                    </div>
                    <div className="mobile-flip-back">
                        <img
                            src={card2Back}
                            alt="Product Back"
                            className="mobile-flip-img"
                        />
                    </div>
                </div>
            </div>

            {/* Card 3 */}
            <div
                className={`mobile-flip-card ${activeCard === 2 ? 'active' : ''}`}
                onClick={() => handleCardClick(2)}
            >
                <div className="mobile-flip-card-inner">
                    <div className="mobile-flip-front">
                        <img
                            src={card3Front}
                            alt="Product Front"
                            className="mobile-flip-img"
                        />
                    </div>
                    <div className="mobile-flip-back">
                        <img
                            src={card3Back}
                            alt="Product Back"
                            className="mobile-flip-img"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileViewCertificate;